<template>
  <div class="borneheader">
    <!-- le nom à indiquer dois etre dans ce format, c'est vuejs qui transforme le nom en minuscule et ajoute les tirets en fonction des majuscules -->
      <h1 class="boisRiquet">
        <div class="texte_titre">Le Bois </div>
        <div class="texte_titre2">de Riquet</div>
      </h1>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
    
  },
  data: () => ({
   
  }),
  methods: {
  }
}


  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.borneheader{
  display: flex;
 // justify-content: flex-end;
  margin-bottom: 60px;

  margin-right: 20px;
//  flex-direction: row;
 // padding-bottom: 10px;
 // flex-wrap: wrap;
 // margin-left: auto;
}

h1{
  display: flex;
  flex-direction:column;
//  margin-bottom: 0;
//  padding-bottom: 10px;
//  flex-wrap: wrap;
//  flex-basis:100%;
//  justify-content: flex-start;
//  width: auto;
}

.texte_titre{
  display:flex;
//  align-self: flex-end;
  justify-content: center;
}
.texte_titre2{
  //align-items:center;
  //flex-basis:100%;
//  align-self: flex-end;
  border-bottom: solid 1px red;
  padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/BorneHeader.vue